import CadreMandat from '../components/CadreMandat';

function PoleMandat({ listeMembres, pole }) {
    return (
        <div className="flex flex-col items-center md:items-start px-4 md:px-0">
            <div className="w-full max-w-[1200px] mb-8">
                <h1 className="text-[32px] leading-[38px] font-semibold text-gris-sombre dark:text-blanc-sombre text-center md:text-left">{pole}</h1>
            </div>
            <div className="flex flex-wrap w-full max-w-[1200px] justify-center md:justify-start gap-y-6">
                {listeMembres.map((membre, index) => (
                    <div key={index} className="w-full max-w-[250px]">
                        <CadreMandat nom={membre.nom} role={membre.role} linkedln={membre.linkedln} mail={membre.mail} photo={membre.photo}/>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default PoleMandat;